import React from "react";
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";
import BasicButton from "../SharedComponents/BasicButton/BasicButton";
import SelectField from "../SharedComponents/SelectField/SelectField";
import BasicLabel from "../SharedComponents/BasicLabel/BasicLabel";
import { withUserContext } from "../../contexts/UserContext";
import BasicTabs from "../SharedComponents/BasicTabs/BasicTabs";
import BasicCheckbox from "../SharedComponents/BasicCheckbox/BasicCheckbox";
import BasicTextField from "../SharedComponents/BasicTextField/BasicTextField";
import BasicTextArea from "../SharedComponents/BasicTextArea/BasicTextArea";
import "./ShowsModal.scss";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import MessageModal from "../SharedComponents/MessageModal";
import {
  criteriaList,
  OperatorList,
  GroupByOption,
  initialUserDetails,
} from "./Config";
import { getFormattedDate, validateNumbersOnly } from "../../Common/Helper";
import { CircularProgress } from "@material-ui/core";
import * as Constants from "../../constants/constants";
import PostWatchService from "../../services/service";
import _ from "lodash";
import Button from "@material-ui/core/Button";
import Message from "../../Common/Messages.json";
import { MDBIcon } from "mdbreact";
import DateField from "../SharedComponents/DateField/DateField";

const emptySeasonForm = {
  seasonDropDownValue: null,
  seasonSelected: null,
  duplicateSeasonEror: false,
  currentPoSTartNo: null,
  currents4_code: null,
  validateS4code: false,
  current_task: null,
  current_task_description: null,
  current_tx_date: null,
  current_rt_minutes: null,
  current_show_season_id: null,
  editShowSeasonId: null,
};

class NewTenantShowEpisodes extends React.Component {
  constructor(props) {
    super(props);
    this.deleteItem = null;
    this.placeHolderObj_ProdCompany = {
      prod_company_id: null,
      currency_id: null,
      exchange_rate: null,
      is_deleted: 0,
    };
    this.placeHolderObj_Episode = {
      episode_id: null,
      episode_name: null,
      gl_number: null,
      is_deleted: 0,
    };
    this.seasonSelectedIndexCopy = null;
    this.state = {
      userPostJson: null,
      isFetchingEpisodes: false,
      postInitiated: false,
      reportsTabs: [
        { tab_id: 1, tab_name: "Details" },
        { tab_id: 2, tab_name: "Episodes" },
      ],
      selectedTabValue: 1,
      criteriaDetails: null,
      operator: null,
      filters: { comp_name: null, page: null, rowsPerPage: null },
      productionCompanies: null,
      isFetchingCurrencies: false,
      currencies: null,
      haveUnsavedChanges: false,
      isMessageModalOpen: false,
      seasonsList: null,
      ...emptySeasonForm,
      episodeSelected: null,
      seasonSelectedIndex: null,
      hasError: false,
      isConfirmMessageModalOpen: false,
      isErrorMessageModalOpen: false,
    };
  }
  componentDidMount = () => {
    // For both New and Existing show
    this.getEpisodes(this.props.show_id);
    this.getSeasons();
  };

  getTenantId = () =>
    this.props?.userContext?.active_tenant?.tenant_id ||
    this.props?.userContext?.user_profile?.tenant_id;

  getEpisodes = (showId) => {
    this.setState({ isFetchingEpisodes: true });
    PostWatchService.getData(
      Constants.postWatchServiceBaseUrl + "/getshowepisodes?showId=" + showId,
      this.getTenantId()
    ).then(
      (response) => {
        this.setState(
          {
            userPostJson: response.data[0],
            backupInitialResponse: response.data[0],
            isFetchingEpisodes: false,
          },
          () => {
            if (this.state.userPostJson?.show_season?.length > 0) {
              this.handleOnSeasonSelect(0);
            }
          }
        );
      },
      (err) => {
        this.setState({ isFetchingEpisodes: false });
      }
    );
  };

  getSeasons = () => {
    PostWatchService.getData(
      Constants.postWatchServiceBaseUrl + "/getseasons",
      this.getTenantId()
    ).then(
      (response) => {
        if(this.getTenantId() === 3){
          this.setState({
            seasonsList: response.data?.length>0 ? response.data?.filter(item => item?.is_active === 1) : []
          });
        }else{
          this.setState({
            seasonsList: response.data,
          });
        }
      },
      (err) => {
        console.log("error in get seasons");
      }
    );
  };

  handleOnChange = (field, value) => {
  this.setState({[`current_${field}`] : value})
  };

  handlePOStartNoChange = (value) => {    
     this.setState({ currentPoSTartNo:value});
  };

  handleS4CodeChange = (value) => {
    if(value.length === 0){
      this.setState({validateS4code:false});
    }else if(value.length > 0 && value.length <=10){
      const regex = /^[A-Za-z]\d{2}\.\d{6}$/;
      const validStatus = !regex.test(value);
      this.setState({validateS4code:validStatus});
    }else if(value.length > 10 && value.length <=13){
      const regex = /^[A-Za-z]\d+\.\d{6,}\.\d{2}$/;
      const validStatus = !regex.test(value);
      this.setState({validateS4code:validStatus});
    }
    else if(value.length > 13 && value.length <=16){
      const regex = /^[A-Za-z]\d{2}\.\d{6}\.\d{2}\.\d{2}$/;
      const validStatus = !regex.test(value);
      this.setState({validateS4code:validStatus});
    }
    else if(value.length > 16 && value.length <=19){
      const regex = /^[A-Za-z]\d{2}\.\d{6}\.\d{2}\.\d{2}\.\d{2}$/;
      const validStatus = !regex.test(value);
      this.setState({validateS4code:validStatus});
    }else{
      this.setState({validateS4code:true});
    }

    this.setState({ currents4_code:value });
  };

  handleEpisodeChange = (field, index, value) => {
    let userPostJson = JSON.parse(JSON.stringify(this.state.userPostJson));
    userPostJson.show_season[this.state.seasonSelectedIndex].episodes[index][
      field
    ] = value;
    this.setState({ userPostJson, haveUnsavedChanges: true });
    this.props.updatehaveUnsavedChanges(true);
  };

  addEpisode = () => {
    let userPostJson = JSON.parse(JSON.stringify(this.state.userPostJson));
    if (userPostJson.show_season[this.state.seasonSelectedIndex]?.episodes) {
      if (
        !_.find(
          userPostJson.show_season[this.state.seasonSelectedIndex].episodes,
          this.placeHolderObj_Episode
        )
      ) {
        userPostJson.show_season[this.state.seasonSelectedIndex].episodes.push({
          ...this.placeHolderObj_Episode,
        });
      }
    }
    this.setState({ userPostJson, haveUnsavedChanges: true });
    this.props.updatehaveUnsavedChanges(true);
  };
  removeEpisode = (index) => {
    let userPostJson = JSON.parse(JSON.stringify(this.state.userPostJson));
    const episodes =
      userPostJson.show_season[this.state.seasonSelectedIndex].episodes;
    episodes[index].is_deleted = 1;
    if (!episodes.some((episode) => episode.is_deleted === 0)) {
      episodes.push({ ...this.placeHolderObj_Episode });
    }
    this.setState({ userPostJson, haveUnsavedChanges: true });
    this.props.updatehaveUnsavedChanges(true);
  };

  removeProdCompany = (index) => {
    let userPostJson = JSON.parse(JSON.stringify(this.state.userPostJson));
    // userPostJson.prod_companies.splice(index, 1);
    userPostJson.prod_companies[index].is_deleted = 1;
    this.setState({ userPostJson, haveUnsavedChanges: true });
  };

  addOtherCurrency = () => {
    let userPostJson = JSON.parse(JSON.stringify(this.state.userPostJson));
    if (userPostJson?.other_show_currencies) {
      userPostJson.other_show_currencies.push({
        ...this.placeHolderObj_OtherCurrency,
      });
    }
    this.setState({ userPostJson, haveUnsavedChanges: true });
  };
  removeOtherCurrency = (index) => {
    let userPostJson = JSON.parse(JSON.stringify(this.state.userPostJson));
    // userPostJson.other_show_currencies.splice(index, 1);
    userPostJson.other_show_currencies[index].is_deleted = 1;
    this.setState({ userPostJson, haveUnsavedChanges: true });
  };

  validateBeforeSave = (userPostJson) => {
    let canSubmit =
      userPostJson?.show_name?.length > 0 &&
      userPostJson?.po_prefix?.length > 0;
    return canSubmit;
  };

  convertToNumbers = (userPostJson) => {
    if (userPostJson?.prod_companies?.length > 0) {
      _.forEach(userPostJson.prod_companies, (obj) => {
        obj.exchange_rate = parseFloat(obj.exchange_rate);
      });
    }
    if (userPostJson?.other_show_currencies?.length > 0) {
      _.forEach(userPostJson.other_show_currencies, (obj) => {
        obj.other_curr_exch_rate = parseFloat(obj.other_curr_exch_rate);
      });
    }
    return userPostJson;
  };
  clearEmptyEpisodes = (show_season) => {
    _.forEach(show_season, (item) => {
      item.episodes = item.episodes.filter(
        (obj) =>
          obj.episode_name &&
          obj.gl_number &&
          !(obj.is_deleted === 1 && !obj.episode_id)
      );
    });
    return show_season;
  };
  onSave = () => {
    this.setState({ postInitiated: true });
    let userPostJson = JSON.parse(JSON.stringify(this.state.userPostJson));
    if (this.getTenantId() !== 3) {
      let show_season = this.clearEmptyEpisodes(userPostJson.show_season);
      userPostJson.show_season = show_season;
    }   
    if (this.validateBeforeSave(userPostJson)) {
      if (this.getTenantId() !== 2 && this.getTenantId() !== 3) {
      userPostJson.show_season =
        userPostJson.show_season[this.state.seasonSelectedIndex];
      }
      this.saveShowEpisodes(userPostJson);
    }
  };

  saveShowEpisodes = (userPostJson) => {
    this.setState({ isFetchingEpisodes: true });
    let tempPostJson = null;
    if(this.getTenantId() === 3){
      let deletedSeasons= this.state.backupInitialResponse?.show_season.filter(obj1 => !userPostJson?.show_season.some(obj2 => obj2.season_id === obj1.season_id));
      deletedSeasons.map((item)=>{
        item["is_delete"]=1;
      })
      tempPostJson = userPostJson?.show_season?.concat(deletedSeasons);
      userPostJson.show_season = tempPostJson;
    }
    

    PostWatchService.postData(
      Constants.postWatchServiceBaseUrl +
        `/postshowepisodes?userId=` +
        this.props?.userContext?.user_profile?.user_id,
        userPostJson,
      this.getTenantId()
    ).then(
      (response) => {
        if (response.data[0]?.Level === "Error") {
          this.setState({
            isFetchingEpisodes: false,
            hasError: response.data[0]?.Message,
            userPostJson: this.state?.backupInitialResponse
          });
        } else {
          this.setState({
            haveUnsavedChanges: false,
            isFetchingEpisodes: false,
            postInitiated: false,
            hasError: false,
          });
          this.getEpisodes(this.props.show_id);
          this.props.updatehaveUnsavedChanges(false);
          this.props?.onSave();
        }
      },
      (err) => {
        this.setState({ isFetchingEpisodes: false, hasError: false });
        console.log("Post polineitem error:" + err);
      }
    );
  };
  onSeasonSelection = (value) => {    
    this.setState({ seasonDropDownValue: value, hasError: false },()=>{
      this.checkDuplicateSeason();
    });
  };

  checkDuplicateSeason = () => {
    let season = _.find(this.state.userPostJson?.show_season, {
      season_id: this.state.seasonDropDownValue,
    });
    if (season) {
      this.setState({ duplicateSeasonEror: true });
      return true;
    } else {
      this.setState({ duplicateSeasonEror: false });
      return false;
    }
  };

  editShowSeason(showDetails){
    this.setState({seasonDropDownValue:showDetails?.season_id,currentPoSTartNo:showDetails?.po_start_no,
          currents4_code:showDetails?.s4_code,
          current_task:showDetails?.task,
          current_task_description:showDetails?.task_description,
          current_tx_date:showDetails?.tx_date,
          current_rt_minutes:showDetails?.rt_minutes,
          current_show_season_id: showDetails?.show_season_id,
          editShowSeasonId:showDetails?.season_id,
          validateS4code:false
    })
    //this.removeShowSeason(showDetails);
    
  }

  removeShowSeason(showDetails){
    const userPostJson = JSON.parse(JSON.stringify(this.state.userPostJson));
    const selectedSeasonId =
      userPostJson?.show_season?.[this.state.seasonSelectedIndex]?.season_id;
    userPostJson.show_season = userPostJson?.show_season?.filter(
      season => season.season_id !== showDetails?.season_id
    );
    const seasonSelectedIndex = userPostJson.show_season.findIndex(
      season => season.season_id === selectedSeasonId
    );
    this.setState({
      userPostJson,
      seasonSelectedIndex:
        seasonSelectedIndex === -1 ? null : seasonSelectedIndex,
      seasonSelected:
        seasonSelectedIndex === -1
          ? null
          : userPostJson.show_season[seasonSelectedIndex],
      haveUnsavedChanges: true,
    });
    this.props.updatehaveUnsavedChanges(true);
  }

  addSeason = () => {
    const isHboTenant = this.getTenantId() === 2;
    if (!this.state.seasonDropDownValue) {
      return;
    }

    if (!this.state.editShowSeasonId) {
      if (this.checkDuplicateSeason()) {
        return;
      }

      let userPostJson = JSON.parse(JSON.stringify(this.state.userPostJson));
      let item = _.find(this.state.seasonsList, {
        season_id: this.state.seasonDropDownValue,
      });
      if (item) {
        const newSeason = {
          season_id: item.season_id,
          season_name: item.season_name,
          show_season_id: this.state.current_show_season_id ?? null,
          po_start_no: this.state.currentPoSTartNo,
          s4_code:this.state.currents4_code,
          task:this.state.current_task,
          task_description:this.state.current_task_description,
          ...(isHboTenant && {
            tx_date:this.state.current_tx_date,
            rt_minutes:this.state.current_rt_minutes,
          }),
          episodes: isHboTenant ? [{ ...this.placeHolderObj_Episode }] : [],
        };
        userPostJson.show_season.push(newSeason);
        this.setState({
          userPostJson,
          ...emptySeasonForm,
          ...(isHboTenant && {
            seasonSelected: newSeason,
            seasonSelectedIndex: userPostJson.show_season.length - 1,
          }),
        });
        this.props.updatehaveUnsavedChanges(true);
      }
      return;
    }

    let userPostJson = JSON.parse(JSON.stringify(this.state.userPostJson));
    const seasonIndex = userPostJson.show_season.findIndex(
      season => season.season_id === this.state.seasonDropDownValue
    );

    if (seasonIndex === -1) {
      return;
    }

    userPostJson.show_season[seasonIndex] = {
      ...userPostJson.show_season[seasonIndex],
      show_season_id: this.state.current_show_season_id ?? null,
      po_start_no: this.state.currentPoSTartNo,
      s4_code: this.state.currents4_code,
      task: this.state.current_task,
      task_description: this.state.current_task_description,
      ...(isHboTenant && {
        tx_date: this.state.current_tx_date,
        rt_minutes: this.state.current_rt_minutes,
      })
    };
    this.setState({ userPostJson, ...emptySeasonForm });
    this.props.updatehaveUnsavedChanges(true);
  };
  selectSeason = (index) => {
    let userPostJson = JSON.parse(JSON.stringify(this.state.userPostJson));
    const season = userPostJson.show_season[index];
    if (!season) {
      return;
    }
    season.episodes = season.episodes || [];
    if (!_.find(season.episodes, this.placeHolderObj_Episode)) {
      season.episodes.push({
        ...this.placeHolderObj_Episode,
      });
    }
    this.setState({
      seasonSelected: season,
      seasonSelectedIndex: index,
      hasError: false,
      userPostJson,
    });
  };

  handleOnSeasonSelect = (index) => {
    if (this.state.seasonSelectedIndex === index) {
      return false;
    }
    if (this.getTenantId() === 2) {
      this.selectSeason(index);
      return;
    }
    if (this.state.haveUnsavedChanges) {
      // this.props.handleMessageModalStatus("unsaved", true);
      this.seasonSelectedIndexCopy = index;
      this.setState({ isMessageModalOpen: true });
    } else {
      this.selectSeason(index);
    }
  };

  onModalConfirm = () => {
    this.setState(
      {
        haveUnsavedChanges: false,
        isMessageModalOpen: false,
      },
      () => {
        this.handleOnSeasonSelect(this.seasonSelectedIndexCopy);
      }
    );

    this.props.updatehaveUnsavedChanges(false);
  };

  onDeleteSeason = () => {
    if (
      this.state.seasonSelectedIndex !== null &&
      this.state.seasonSelectedIndex >= 0
    ) {
      this.deleteItem = this.state.userPostJson;
      this.setState({ isConfirmMessageModalOpen: true });
    }
  };
  onModalDeleteConfirm = () => {
    let item = { ...this.deleteItem };
    item.is_deleted = 1;
    this.postDelete();
  };
  onErrorModalConfirm = () => {
    this.setState({
      isErrorMessageModalOpen: false,
    });
    this.deleteItem = null;
  };

  postDelete = () => {
    this.setState({ isFetchingEpisodes: true });
    PostWatchService.postDataWithoutPayload(
      Constants.postWatchServiceBaseUrl +
        `/deleteshowseason?userId=` +
        this.props?.userContext?.user_profile?.user_id +
        "&showSeasonId=" +
        this.state.userPostJson?.show_season[this.state.seasonSelectedIndex]
          ?.show_season_id,
      this.getTenantId()
    ).then(
      (response) => {
        if (response.data[0]?.Level === "Error") {
          this.setState({
            isErrorMessageModalOpen: true,
            isConfirmMessageModalOpen: false,
            isFetchingEpisodes: false,
          });
        } else {
          this.setState({
            isConfirmMessageModalOpen: false,
            isFetchingEpisodes: false,
            seasonSelected: null,
            seasonSelectedIndex: null,
          });
          this.getEpisodes(this.props.show_id);
          this.props?.onSave();
          this.deleteItem = null;
        }
      },
      (err) => {
        this.setState({
          isConfirmMessageModalOpen: false,
          isFetchingEpisodes: false,
        });
        console.log("Post polineitem error:" + err);
      }
    );
  };

  renderSeasonActions = (item, showEdit = false) => (
    <div className="actionEditEpisode">
      {showEdit && (
        <MDBIcon
          icon="pen"
          size="sm"
          className="action-icons ms-1"
          onClick={() => this.editShowSeason(item)}
        />
      )}
      <MDBIcon
        icon="times"
        size="sm"
        className="action-icons ms-1"
        onClick={() => this.removeShowSeason(item)}
      />
    </div>
  );

  render() {
    let isLoading = this.state.isFetchingEpisodes;
    const tenantId = this.getTenantId();
    const isHboTenant = tenantId === 2;
    const selectedEpisodes =
      this.state.userPostJson?.show_season[
        this.state.seasonSelectedIndex
      ]?.episodes || [];
    const lastActiveEpisodeIndex = selectedEpisodes.reduce(
      (lastIndex, episode, index) =>
        episode.is_deleted === 1 ? lastIndex : index,
      -1
    );
    return (
      <div>
        {isLoading ? (
          <div className="ContentLoader">
            <CircularProgress />
          </div>
        ) : (
          <div>
            <MDBContainer className="Reports p-0">
              <>
                <MDBRow>
                  <MDBCol md={12}>
                    <MDBRow>
                      <MDBCol md={12} >
                      <MDBRow className={isHboTenant ? "hbo-season-row hbo-season-header" : ""}>
                      <MDBCol md={2}>  <BasicLabel text="Seasons" type={"text"} /> </MDBCol>
                      <MDBCol md={2}> <BasicLabel text="PO Start No" type={"text"} /> </MDBCol>
                      {tenantId !== 3 && <>
                        <MDBCol md={2}> <BasicLabel text="S4 Code" type={"text"} /> </MDBCol>
                        <MDBCol md={2}> <BasicLabel text="Task" type={"text"} /> </MDBCol>
                        <MDBCol md={4}> <BasicLabel text="Task Description" type={"text"} /> </MDBCol>
                        {isHboTenant && <>
                          <MDBCol md={2}> <BasicLabel text="TX Date" type={"text"} /> </MDBCol>
                          <MDBCol md={1} className="hbo-rt-column"> <BasicLabel text="RT (Min)" type={"text"} /> </MDBCol>
                        </>}
                      </>}
                      
                      </MDBRow>
                        <div className={`newtenant-season-button-container${isHboTenant ? " hbo-season-list" : ""}`}>
                          {this.state.userPostJson?.show_season?.map(
                            (item, index) => {
                              return (
                                  <MDBRow
                                    key={item.show_season_id || item.season_id}
                                    className={
                                      isHboTenant
                                        ? `hbo-season-row ${
                                            this.state.seasonSelectedIndex === index
                                              ? "hbo-season-selected"
                                              : ""
                                          }`
                                        : ""
                                    }
                                  >
                                  <MDBCol
                                    md={2}
                                    className={isHboTenant ? "hbo-season-selector" : ""}
                                    role={isHboTenant ? "button" : undefined}
                                    tabIndex={isHboTenant ? 0 : undefined}
                                    onClick={
                                      isHboTenant
                                        ? () => this.handleOnSeasonSelect(index)
                                        : undefined
                                    }
                                    onKeyDown={
                                      isHboTenant
                                        ? (e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                              this.handleOnSeasonSelect(index);
                                            }
                                          }
                                        : undefined
                                    }
                                  >
                                    <span>{item?.season_name}</span>
                                  </MDBCol>
                                  <MDBCol md={2} > 
                                  <span >{item?.po_start_no} </span>
                                  </MDBCol>
                                  {tenantId !== 3 && <>
                                    <MDBCol md={2} > 
                                      <span >{item?.s4_code} </span>
                                    </MDBCol>
                                    <MDBCol md={2} > 
                                      <span >{item?.task} </span>
                                    </MDBCol>
                                    <MDBCol md={4} className="task_desc_cont"> 
                                      <span >{item?.task_description} </span>
                                    </MDBCol>
                                    {isHboTenant && <>
                                      <MDBCol md={2}>
                                        <span>{item?.tx_date ? getFormattedDate(item.tx_date) : ""}</span>
                                      </MDBCol>
                                      <MDBCol md={1}>
                                        <span>{item?.rt_minutes}</span>
                                      </MDBCol>
                                      <MDBCol className="hbo-season-actions">
                                        {this.renderSeasonActions(item, true)}
                                      </MDBCol>
                                    </>}
                                  </>}
                                  {tenantId === 3 &&
                                    <MDBCol md={4} className="task_desc_cont"> 
                                      {this.renderSeasonActions(item)}
                                    </MDBCol>
                                  }
                                  </MDBRow>
                              );
                            }
                          )}
                        </div>
                      </MDBCol>
                    </MDBRow>
                    <MDBRow>
                     
                     
                    </MDBRow>

                    <MDBRow className={isHboTenant ? "hbo-season-row hbo-season-entry" : ""}>
                      <MDBCol md={2} className="p-0">
                        <SelectField
                          size="small"
                          options={
                            this.state.seasonsList?.map((item) => ({
                              value: item.season_id,
                              label: item.season_name,
                              is_active: item.is_active,
                            })) || []
                          }
                          disabled={this.state.current_show_season_id}
                          value={this.state.seasonDropDownValue || null}
                          onChange={(e) => {
                            this.onSeasonSelection(e.target.value);
                          }}
                          placeholder={
                            this.props?.phoneTypePlaceholder || "-Select-"
                          }
                        />
                        </MDBCol>
                        <MDBCol md={2} className="p-0">
                         <BasicTextField
                          //label={"PO Start Nov"}
                          placeholder={"PO Start No"}
                          value={
                            this.state.currentPoSTartNo || ""
                          }
                          disabled={this.state.current_show_season_id}
                          onChange={(e) =>
                            e.target.value.length > 0
                              ? validateNumbersOnly(e.target.value) &&
                                this.handlePOStartNoChange(e.target.value)
                              : this.handlePOStartNoChange(null)
                          }
                          
                        />
                        </MDBCol>
                        {tenantId !== 3 && <>
                          <MDBCol md={2} className="p-0">
                          <BasicTextField
                            isMandatory={false}
                            limit={"50"}
                            inValidInput={"Invalid S4 code"}
                            fieldValid={this.state.validateS4code}
                            placeholder={"S4 Code"}
                            value={
                              this.state.currents4_code || ""
                            }
                            onChange={(e) =>
                              this.handleS4CodeChange(e.target.value)
                            }
                            
                          />
                          </MDBCol>
                          <MDBCol md={2} className="p-0">
                          <BasicTextField
                            isMandatory={false}
                            limit={"50"}
                            placeholder={"Task"}
                            value={
                              this.state.current_task || ""
                            }
                            onChange={(e) =>
                              this.handleOnChange('task',e.target.value)
                            }
                            
                          />
                          </MDBCol>
                          <MDBCol md={4} className="p-0 task_desc_cont">
                          <BasicTextField
                            isMandatory={false}
                            placeholder={"Task Description"}
                            value={
                              this.state.current_task_description || ""
                            }
                            onChange={(e) =>
                              this.handleOnChange('task_description',e.target.value)
                            }
                            
                          />
                          {!isHboTenant && <AddCircleIcon
                            className="m-1"
                            onClick={!this.state.validateS4code && !this.state.duplicateSeasonEror && this.addSeason}
                          />}
                          </MDBCol>
                          {isHboTenant && <>
                            <MDBCol md={2} className="p-0">
                              <DateField
                                value={this.state.current_tx_date}
                                onChange={(e) => this.handleOnChange("tx_date", e.target.value || null)}
                              />
                            </MDBCol>
                            <MDBCol md={1} className="p-0">
                              <BasicTextField
                                limit={"4"}
                                placeholder={"RT (Min)"}
                                value={this.state.current_rt_minutes || ""}
                                onChange={(e) =>
                                  e.target.value.length > 0
                                    ? validateNumbersOnly(e.target.value) &&
                                      this.handleOnChange("rt_minutes", e.target.value)
                                    : this.handleOnChange("rt_minutes", null)
                                }
                              />
                            </MDBCol>
                            <MDBCol className="hbo-season-actions p-0">
                              <AddCircleIcon
                                className="m-1"
                                onClick={!this.state.validateS4code && !this.state.duplicateSeasonEror && this.addSeason}
                              />
                            </MDBCol>
                          </>}
                          </>}
                          {tenantId === 3 && <MDBCol md={4} className="p-0 task_desc_cont">
                          <AddCircleIcon
                            className="m-1"
                            onClick={!this.state.duplicateSeasonEror && this.addSeason}
                          />
                          </MDBCol>}
                        </MDBRow>
                    <MDBRow>
                      <MDBCol md={12} className="p-0 redStar f-65rem mt-1">
                        {this.state?.duplicateSeasonEror && (
                          <span className="redStar">
                            This season already exists
                          </span>
                        )}
                      </MDBCol>
                    </MDBRow>
                    {isHboTenant &&
                      this.state.seasonSelectedIndex !== null && (
                        <div className="hbo-episodes-section">
                          <MDBRow className="hbo-episode-row">
                            <MDBCol md={12} className="groupBy hbo-episodes-title">
                              <BasicLabel
                                text={`${
                                  this.state.userPostJson?.show_season[
                                    this.state.seasonSelectedIndex
                                  ]?.season_name || "Season"
                                }: Episodes`}
                                type={"text"}
                              />
                            </MDBCol>
                          </MDBRow>
                          {selectedEpisodes.map((episode, episodeIndex) =>
                            episode.is_deleted !== 1 ? (
                              <MDBRow
                                key={episode.episode_id || `new-${episodeIndex}`}
                                className="hbo-episode-row"
                              >
                                <MDBCol md={4} className="p-0">
                                  <BasicTextField
                                    placeholder={"GL Number"}
                                    value={episode.gl_number || ""}
                                    onChange={(e) =>
                                      this.handleEpisodeChange(
                                        "gl_number",
                                        episodeIndex,
                                        e.target.value
                                      )
                                    }
                                  />
                                </MDBCol>
                                <MDBCol md={7} className="p-0">
                                  <BasicTextField
                                    placeholder={"Episode Name"}
                                    value={episode.episode_name || ""}
                                    onChange={(e) =>
                                      this.handleEpisodeChange(
                                        "episode_name",
                                        episodeIndex,
                                        e.target.value
                                      )
                                    }
                                  />
                                </MDBCol>
                                <MDBCol md={1} className="hbo-episode-actions p-0">
                                  {(episode.episode_id ||
                                    episode.gl_number ||
                                    episode.episode_name) && (
                                    <RemoveCircleIcon
                                      className="m-1"
                                      onClick={() =>
                                        this.removeEpisode(episodeIndex)
                                      }
                                    />
                                  )}
                                  {episode.gl_number &&
                                    episode.episode_name &&
                                    episodeIndex === lastActiveEpisodeIndex && (
                                      <AddCircleIcon
                                        className="m-1"
                                        onClick={this.addEpisode}
                                      />
                                    )}
                                </MDBCol>
                              </MDBRow>
                            ) : null
                          )}
                        </div>
                      )}
                  </MDBCol>
                  <MDBCol md={9}>
                    <MDBRow>
                      <MDBCol md={4} className="p-0">                       
                      </MDBCol>                     
                    </MDBRow>                   
                  </MDBCol>
                </MDBRow>

                <MDBRow className="btn-row">
                  <MDBCol md={8}>
                    {this.state?.hasError && (
                      <span className="redStar f-65rem">
                        {this.state?.hasError}
                      </span>
                    )}
                  </MDBCol>
                  <MDBCol md={2}>
                    <BasicButton
                      variant="contained"
                      type="inline"
                      text={"Save"}
                      onClick={this.onSave}
                    />
                  </MDBCol>
                  <MDBCol md={2}>
                    <BasicButton
                      type="inline"
                      variant="outlined"
                      text={"Cancel"}
                      onClick={this.props.onClose}
                      disabled={false}
                    />
                  </MDBCol>
                </MDBRow>
                <MessageModal
                  open={this.state.isMessageModalOpen}
                  showError={this.state.haveUnsavedChanges || false}
                  primaryButtonText={"Ok"}
                  secondaryButtonText={"Cancel"}
                  hideCancel={false}
                  onConfirm={() => this.onModalConfirm()}
                  handleClose={(e) =>
                    this.setState({ isMessageModalOpen: false })
                  }
                />

                {this.state?.isConfirmMessageModalOpen && (
                  <MessageModal
                    open={this.state.isConfirmMessageModalOpen}
                    showCustom={true}
                    message={Message.deleteAdmin}
                    title={"Confirm Deletion"}
                    primaryButtonText={"Ok"}
                    secondaryButtonText={"Cancel"}
                    hideCancel={false}
                    onConfirm={() => this.onModalDeleteConfirm()}
                    handleClose={(e) =>
                      this.setState({ isConfirmMessageModalOpen: false })
                    }
                  />
                )}
                {this.state?.isErrorMessageModalOpen && (
                  <MessageModal
                    open={this.state.isErrorMessageModalOpen}
                    showCustom={true}
                    message={Message.deleteAdminError}
                    title={"Message"}
                    primaryButtonText={"Ok"}
                    hideCancel={true}
                    onConfirm={() => this.onErrorModalConfirm()}
                    handleClose={(e) =>
                      this.setState({ isErrorMessageModalOpen: false })
                    }
                  />
                )}
              </>
            </MDBContainer>
          </div>
        )}
      </div>
    );
  }
}

export default withUserContext(NewTenantShowEpisodes);
